var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrillCashPlus0B663Ff9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.744141 9.66667V36.3333C0.744141 38.1014 1.44652 39.7971 2.69676 41.0474C3.94701 42.2976 5.6427 43 7.41081 43H40.7441C42.5123 43 44.208 42.2976 45.4582 41.0474C46.7084 39.7971 47.4108 38.1014 47.4108 36.3333V16.3333C47.4108 14.5652 46.7084 12.8695 45.4582 11.6193M0.744141 9.66667H37.4108M0.744141 9.66667V6.33333C0.744141 5.44928 1.09533 4.60143 1.72045 3.97631C2.34557 3.35119 3.19342 3 4.07747 3H34.0775C34.9615 3 35.8094 3.35119 36.4345 3.97631C36.7003 4.24211 36.9166 4.54818 37.0774 4.88018",
    stroke: "#5995C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4115 29.6667C39.2524 29.6667 40.7448 28.1743 40.7448 26.3333C40.7448 24.4924 39.2524 23 37.4115 23C35.5705 23 34.0781 24.4924 34.0781 26.3333C34.0781 28.1743 35.5705 29.6667 37.4115 29.6667Z",
    fill: "#5995C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6279 6.24023H48.6631V8.23242H42.6279V14.4434H40.6211V8.23242H34.5859V6.24023H40.6211V0H42.6279V6.24023Z",
    fill: "#5995C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrillCashPlus0B663Ff9);
export default __webpack_public_path__ + "static/media/thrill-cash-plus-0b663ff9.ab71ab1c0b6d3dd10c68533388d62c15.svg";
export { ForwardRef as ReactComponent };